import { ENDPOINTS } from 'config/endpoints';
import {
  QueryClient,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import CronoError from 'crono-fe-common/types/error';

export default function useSyncCrmPipelines() {
  const queryClient = useQueryClient();

  const syncPipelines = () => {
    const request: Request = {
      url: `${ENDPOINTS.pipeline.sync}`,
      config: {
        method: 'post',
      },
    };
    return client(request);
  };

  return useMutation<Response<null>, CronoError>(syncPipelines, {
    onSettled: (_result, _error, _variables) => {
      invalidateSyncCrmPipelines(queryClient);
    },
  });
}

export const invalidateSyncCrmPipelines = (queryClient: QueryClient) => {
  queryClient.invalidateQueries([ENDPOINTS.pipeline.main]);
  queryClient.invalidateQueries([ENDPOINTS.pipeline.sync]);
  queryClient.invalidateQueries([ENDPOINTS.opportunity.main]);
  queryClient.invalidateQueries([ENDPOINTS.opportunity.search.main]);
  queryClient.invalidateQueries([ENDPOINTS.opportunity.search.list]);
  queryClient.invalidateQueries([ENDPOINTS.opportunity.search.account]);
};
